import { breakpoints, matchBreakpoint } from "../common/utils";

(() => {
  const head = $("[data-nav-head]");
  const initCHNav = (e, self) => {
    e.preventDefault();
    const headData = self.data("nav-head");
    const body = $("[data-nav-body=" + headData + "]");

    body.toggleClass("opened");
    self.toggleClass("opened");
    $("body").toggleClass("backdrop");
    body.css("height", "calc( 100vh - " + body.offset().top + "px)");
  };

  $(window).on("load", () => {
    if (matchBreakpoint(breakpoints.lg, "max")) {
      head.each(function() {
        let self = $(this);

        self.on("click", e => initCHNav(e, self));
      });
    }
  });
})();
